/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_SeatInputs */



/**
* | output |
* | --- |
* | "Seat the final" |
*
* @param {League_Final_SeatInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_seat = /** @type {((inputs?: League_Final_SeatInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_SeatInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placer la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sentar la final")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Montar a final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disponi la finale")
	return /** @type {LocalizedString} */ ("Seat the final")
});